module.exports = __webpack_public_path__ + "img/header_banner_noti.9868e2bd.svg";